import { render, staticRenderFns } from "./common-patient.vue?vue&type=template&id=25e3b4d4&scoped=true&"
import script from "./common-patient.vue?vue&type=script&lang=ts&"
export * from "./common-patient.vue?vue&type=script&lang=ts&"
import style0 from "./common-patient.vue?vue&type=style&index=0&id=25e3b4d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3b4d4",
  null
  
)

export default component.exports